module.exports = __webpack_public_path__ + "media/images/arrow_left_full-f26475a4b2906d471cb5dea6e460b247.svg";